<template>
    <div/>
</template>

<script>
import { mapGetters } from "vuex";
import AvatarEdit from "./AvatarEdit";

export default {
    name: 'AvatarEditPopup',
    components: {
    },
    data() {
        return {
            avatar: {},
            passwordConfirm: "",
            isOpen: false,
        }
    },
    computed: {
        ...mapGetters(["isMobile"]),
        dialogWidth() {
            return this.isMobile ? 300 : 300;
        },
        dialogHeight() {
            return this.isMobile ? "95%" : "600";
        },
    },
    watch: {

    },
    created() {
        this.ShowDialog();
    },
    methods: {
        OnClose() {
            const self = this;

            self.$emit('Close');
        },
        OnSuccess() {
            const self = this;

            self.$emit('Success');
        },
        ShowDialog() {
            const self = this;

            self.CloseDialog();

            let onClickSave = (e) => {
                self.ClickSave();
            }

            let onClickClose = (e) => {
                self.CloseDialog();
            }

            self.$dialog.open({
                title: "Profile Picture",
                width: self.dialogWidth,
                height: self.dialogHeight,
                resizable: false,
                draggable: false,
                okOnly: true,
                okTitle: "OK",
                closeOnEsc: true,
                hideHeaderClose: true,
                scrollable: true,
                component: AvatarEdit,
                buttons: [
                    { title: "Cancel", automationId: "btn_dm_modal_cancel", cssClass: "btn btn-secondary", isVisible: true, closeOnComplete: false, onClick: onClickClose },
                    { title: "Accept", automationId: "btn_dm_modal_accept", cssClass: "btn btn-primary", isVisible: true, closeOnComplete: false, onClick: onClickSave },
                ],
                onOpened: () => { self.isOpen = true },
                onCancel: onClickClose,
                onComponentAction(e) {
                    if (e.originalEvent.name == 'Updated'){
                        self.avatar = e.originalEvent.data;
                    }
                    if (e.originalEvent.name == 'Open'){
                        self.isOpen = true;
                    }
                    return false;
                }
            });
        },
        CloseDialog() {
            const self = this;

            if (self.isOpen){
                self.$dialog.close();
                self.isOpen = false;

                self.$emit('Close');
            }
        },
        ClickSave() {
            const self = this;

            // Make sure everything is valid.
            // if (!self.validated) {
            //     var message = "<div><p>Your password has not met all requirements. Please review.</div>"
            //     self.MessageBox("Invalid Input", message);
            //     return;
            // }

            // Must call save.
            //self.ConfirmPrompt();
            self.$emit('Updated', self.avatar);

            self.CloseDialog();
        },
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>